import React, { useId } from 'react';

export function EverydayDealsIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  const clipId = useId();
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M2.38477 3.55469H17.6191C17.6191 3.55469 18.791 3.55469 18.791 4.72656V17.6172C18.791 17.6172 18.791 18.7891 17.6191 18.7891H2.38477C2.38477 18.7891 1.21289 18.7891 1.21289 17.6172V4.72656C1.21289 4.72656 1.21289 3.55469 2.38477 3.55469Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.38477 3.55469H17.6191C17.6191 3.55469 18.791 3.55469 18.791 4.72656V17.6172C18.791 17.6172 18.791 18.7891 17.6191 18.7891H2.38477C2.38477 18.7891 1.21289 18.7891 1.21289 17.6172V4.72656C1.21289 4.72656 1.21289 3.55469 2.38477 3.55469Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.21289 8.24219H18.791'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.21289 8.24219H18.791'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.90039 5.3125V1.21094'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.90039 5.3125V1.21094'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.1035 5.3125V1.21094'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.1035 5.3125V1.21094'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
